import React from "react";
import styleObj from "./style.module.scss";

export default function Btn(props) {
  let { href, text, meta } = props;
  return (
    <>
      {meta?.is2021 ? (
        <a
          className={`${styleObj["buy-btn"]} ${styleObj["buy-btn-2021"]}`}
          href={href}
          target="blank"
        >
          {text}
        </a>
      ) : (
        <a className={styleObj["buy-btn"]} href={href} target="blank">
          {text}
        </a>
      )}
    </>
  );
}
